import { createMultiStyleConfigHelpers, } from "@chakra-ui/styled-system";
import { CaretSide, VisualBlockSizes, } from "../VisualBlock.types";
function getCaretStyle(caretIn, caretSide, sizeInPx, bgColor) {
    if (caretIn) {
        switch (caretSide) {
            case CaretSide.TOP:
                return {
                    top: "0",
                    borderTopColor: "semantic.surface.1",
                    borderWidth: `${sizeInPx} ${sizeInPx} 0px ${sizeInPx}`,
                };
            case CaretSide.RIGHT:
                return {
                    right: "0",
                    borderRightColor: "semantic.surface.1",
                    borderWidth: `${sizeInPx} ${sizeInPx} ${sizeInPx} 0px`,
                };
            case CaretSide.LEFT:
                return {
                    left: "0",
                    borderLeftColor: "semantic.surface.1",
                    borderWidth: `${sizeInPx} 0 ${sizeInPx} ${sizeInPx}`,
                };
            case CaretSide.BOTTOM:
            default:
                return {
                    bottom: 0,
                    borderBottomColor: "semantic.surface.1",
                    borderWidth: `0 ${sizeInPx} ${sizeInPx} ${sizeInPx}`,
                };
        }
    }
    else {
        // top right bottom left
        switch (caretSide) {
            case CaretSide.TOP:
                return {
                    top: `-${sizeInPx}`,
                    borderBottomColor: bgColor,
                    borderWidth: `0 ${sizeInPx} ${sizeInPx} ${sizeInPx}`,
                };
            case CaretSide.RIGHT:
                return {
                    right: `-${sizeInPx}`,
                    borderLeftColor: bgColor,
                    borderWidth: `${sizeInPx} 0 ${sizeInPx} ${sizeInPx}`,
                };
            case CaretSide.LEFT:
                return {
                    left: `-${sizeInPx}`,
                    borderRightColor: bgColor,
                    borderWidth: `${sizeInPx} ${sizeInPx} ${sizeInPx} 0px`,
                };
            case CaretSide.BOTTOM:
            default:
                return {
                    bottom: `-${sizeInPx}`,
                    borderTopColor: bgColor,
                    borderWidth: `${sizeInPx} ${sizeInPx} 0 ${sizeInPx}`,
                };
        }
    }
}
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(["mainContainer"]);
const baseStyle = definePartsStyle(({ bgColor, caretSide, caretIn }) => ({
    mainContainer: {
        background: bgColor,
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        h: "100%",
        w: "100%",
        // incision style
        "&:after": Object.assign({ content: '""', borderStyle: "solid", borderColor: "transparent", position: "absolute" }, getCaretStyle(caretIn, caretSide, "40px", bgColor)),
    },
}));
const sizes = {
    sm: definePartsStyle(({ bgColor, caretSide, caretIn }) => ({
        mainContainer: {
            "&:after": Object.assign({}, getCaretStyle(caretIn, caretSide, "24px", bgColor)),
        },
    })),
    md: definePartsStyle({}),
    lg: definePartsStyle(({ bgColor, caretSide, caretIn }) => ({
        mainContainer: {
            "&:after": Object.assign({}, getCaretStyle(caretIn, caretSide, "64px", bgColor)),
        },
    })),
    xl: definePartsStyle(({ bgColor, caretSide, caretIn }) => ({
        mainContainer: {
            "&:after": Object.assign({}, getCaretStyle(caretIn, caretSide, "64px", bgColor)),
        },
    })),
};
const VisualBlockTheme = defineMultiStyleConfig({
    baseStyle,
    sizes,
    defaultProps: {
        size: VisualBlockSizes.MD,
    },
});
export default VisualBlockTheme;
//# sourceMappingURL=VisualBlock.default.js.map